import React from 'react'
import cx from 'classnames'

import {
  Dropdown,
  DropdownPropsContext,
} from 'components/shared/Dropdown/Dropdown'
import { Icon, MoreVerticalIcon } from 'components/shared/Icon/Icon'

import { ICON_SIZES } from './model'

import styles from './DropdownAnchor.module.scss'

type DropdownAnchorProps = {
  ariaLabel?: string
  className?: string
  icon?: React.ComponentProps<typeof Icon>['icon']
  isDisabled?: boolean
  size?: string
}

export const DropdownAnchor = ({
  ariaLabel,
  className,
  icon = MoreVerticalIcon,
  isDisabled = false,
  size,
}: DropdownAnchorProps) => {
  const { isToggled } = React.useContext(DropdownPropsContext)!

  return (
    <Dropdown.Anchor
      className={cx(
        styles.anchor,
        styles.size,
        {
          [styles.active]: isToggled,
        },
        size && styles[size],
        className,
      )}
      {...{ ariaLabel, isDisabled }}
    >
      <Icon
        className={styles.icon}
        size={size && ICON_SIZES[size]}
        {...{ icon }}
      />
    </Dropdown.Anchor>
  )
}
